import * as React from "react";
import { Path } from "react-native-svg";
import { Icon, IIconProps } from "native-base";

const AddContained = (props: IIconProps) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.88 3.879a3 3 0 0 1 4.242 0l.293.293a2 2 0 0 0 1.415.586h.414a3 3 0 0 1 3 3v.415a2 2 0 0 0 .586 1.414l.292.292a3 3 0 0 1 0 4.243l-.292.293a2 2 0 0 0-.586 1.414v.417a3 3 0 0 1-3 3h-.417a2 2 0 0 0-1.414.586l-.291.291a3 3 0 0 1-4.243 0l-.29-.291a2 2 0 0 0-1.415-.586h-.417a3 3 0 0 1-3-3v-.417a2 2 0 0 0-.586-1.415l-.292-.292a3 3 0 0 1 0-4.243l.292-.292a2 2 0 0 0 .586-1.414v-.415a3 3 0 0 1 3-3h.414a2 2 0 0 0 1.415-.586l.293-.293Zm2.165 3.078a1 1 0 0 1 1 1v2.5a.5.5 0 0 0 .5.5h2.5a1 1 0 1 1 0 2h-2.5a.5.5 0 0 0-.5.5v2.5a1 1 0 1 1-2 0v-2.5a.5.5 0 0 0-.5-.5h-2.5a1 1 0 1 1 0-2h2.5a.5.5 0 0 0 .5-.5v-2.5a1 1 0 0 1 1-1Z"
      fill="currentColor"
      stroke="none"
    />
  </Icon>
);

export default AddContained;
